import { Filter } from '@cubejs-client/core';

// Where an HCP-led country selection (DEFAULT_COUNTRY_MEMBER) is redirected when a query touches one of these
// cubes: the cube cannot reach hcp, or its rows without an HCP must stay visible (insight #5272, anonymous VoC
// responses #5198). Every other cube keeps hcp.country_code, so the selection filters by the HCP's country.
//
// Mirrors CUBES_WITH_OWN_COUNTRY_CODE in infrastructure/cube/conf/country-filter.js, except:
// - FE only: hcos_all_locations, hco_account_plan, hcp_territory, hco_hierarchy (Cube's RLS uses its hcp_hco default).
// - Cube only: voc_customer_feedback_interaction_individual (queried per HCP, never with the global country),
//   personify_hcp_recommendation (queries require hcp_bk), insight_product and insight_employee_field_force (always
//   queried with insight), interaction_aggregate_employee_insight (still filtered by HCP country: known gap).
//
// hco is deliberately NOT listed. It joins hcp via hco -> hcp_hco -> hcp, so an
// HCP-led selection stays hcp.country_code and Cube filters the HCO list by the
// HCP's country, pruning orphan HCOs (no matching HCP in the selected country).
// Rewriting it to hco.country_code (or the RLS column hcp_hco.hcp_hco_country_code,
// which tracks the HCO's own country) returned every HCO in the country and made
// the HCP tab produce the same result as the HCO tab (work item #4070). The HCO
// tab sends hco.country_code directly, which is never DEFAULT_COUNTRY_MEMBER and so
// is never rewritten, so the two tabs now produce distinct queries.
const CUBES_WITH_OWN_COUNTRY_CODE: Readonly<Record<string, string>> = {
  hcos_all_locations: 'hcos_all_locations.country_code',
  hco_account_plan: 'hco_account_plan.country_code',
  hcp_territory: 'hcp_territory.country_code',
  partnerscore: 'partnerscore.country_code',
  competitor_partner_score: 'competitor_partner_score.country_code',
  personify_hcp_recommendation_hist: 'personify_hcp_recommendation_hist.country_cd',
  hco_hierarchy: 'hco.country_code',
  insight: 'insight.country_code',
  insight_tag: 'insight.country_code',
  subnational_sales: 'subnational_sales.row_level_security_country_code',
  voc_customer_feedback: 'voc_customer_feedback.country_code',
  voc_customer_feedback_custom_question: 'voc_customer_feedback_custom_question.country_code',
  voc_to_interaction_link: 'voc_to_interaction_link.voc_to_interaction_link_country_code',
};

const VIEW_COUNTRY_CODE_OVERRIDES: Readonly<Record<string, string>> = {
  hcp_view: 'hcp_view.country_code',
};

export const DEFAULT_COUNTRY_MEMBER = 'hcp.country_code';

export const SECURITY_BYPASS_FILTER: Filter = {
  member: DEFAULT_COUNTRY_MEMBER,
  operator: 'equals',
  values: ['__ALL__'],
};

export function getCountryDimensionForCube(cubeName: string): string {
  return VIEW_COUNTRY_CODE_OVERRIDES[cubeName] ?? CUBES_WITH_OWN_COUNTRY_CODE[cubeName] ?? DEFAULT_COUNTRY_MEMBER;
}
